import { SupportExerciseDTO } from '@/generated';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useEffect, useState } from 'react';

type SupportExerciseModalProps = {
  show: boolean;
  supportExercise?: SupportExerciseDTO;
  onHide: () => void;
  onSave: (supportExercise: SupportExerciseDTO) => void;
};

export const SupportExerciseModal = (props: SupportExerciseModalProps) => {
  const [draft, setDraft] = useState<SupportExerciseDTO>();

  useEffect(() => {
    if (props.show) setDraft(props.supportExercise ? { ...props.supportExercise } : undefined);
  }, [props.show, props.supportExercise]);

  return (
    <Dialog open={props.show} onClose={props.onHide} fullWidth maxWidth="sm">
      <DialogTitle>Support exercise description</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={4}
          sx={{ mt: 1 }}
          label="Description"
          value={draft?.description ?? ''}
          onChange={(event) => setDraft((current) => (current ? { ...current, description: event.target.value || undefined } : current))}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onHide}>Cancel</Button>
        <Button disabled={!draft} onClick={() => draft && props.onSave(draft)}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
